import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCommentsFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.7453 4.25473C12.8493 1.35878 8.25065 1.07101 5.01626 3.58334L4.85385 3.7128L4.69555 3.84565C1.83117 6.31175 1.04805 10.4396 2.81021 13.7834L2.8769 13.9056L2.20876 16.2457L2.18433 16.3469C2.10393 16.7536 2.23048 17.1768 2.52684 17.4732L2.60349 17.5437L2.68493 17.607C2.99169 17.8259 3.38496 17.8968 3.75437 17.7913L6.09315 17.1225L6.21668 17.1899L6.39983 17.2835C9.83266 18.9835 14.0322 18.0537 16.4167 14.9837C18.929 11.7493 18.6412 7.15068 15.7453 4.25473ZM12.5 10.6563C12.8452 10.6563 13.125 10.9361 13.125 11.2813C13.125 11.6018 12.8838 11.8659 12.5729 11.9021L12.5 11.9063H7.50003C7.15485 11.9063 6.87503 11.6264 6.87503 11.2813C6.87503 10.9607 7.1163 10.6966 7.42714 10.6605L7.50003 10.6563H12.5ZM13.125 8.78126C13.125 8.43608 12.8452 8.15626 12.5 8.15626H7.50003L7.42714 8.16046C7.1163 8.19656 6.87503 8.46073 6.87503 8.78126C6.87503 9.12643 7.15485 9.40626 7.50003 9.40626H12.5L12.5729 9.40205C12.8838 9.36595 13.125 9.10178 13.125 8.78126Z"
	})
});
export default SvgCommentsFilled;
